namespace GeniuzPOS.InitialData {
    export interface PsSalesmanGroupRow {
        Id?: number;
        SalesmanGroup?: string;
        SalesmanGroupDesc?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PsSalesmanGroupRow {
        export const idProperty = 'SalesmanGroup';
        export const nameProperty = 'SalesmanGroupDesc';
        export const localTextPrefix = 'InitialData.PsSalesmanGroup';
        export const lookupKey = 'InitialData.PsSalesmanGroup';

        export function getLookup(): Q.Lookup<PsSalesmanGroupRow> {
            return Q.getLookup<PsSalesmanGroupRow>('InitialData.PsSalesmanGroup');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:พนักงานขาย:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:พนักงานขาย:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:พนักงานขาย:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:พนักงานขาย:Modify';

        export declare const enum Fields {
            Id = "Id",
            SalesmanGroup = "SalesmanGroup",
            SalesmanGroupDesc = "SalesmanGroupDesc",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
